"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoType;
(function (VideoType) {
    VideoType["CAMERA"] = "CAMERA";
    VideoType["SCREEN"] = "SCREEN";
    VideoType["CUSTOM"] = "CUSTOM";
})(VideoType = exports.VideoType || (exports.VideoType = {}));
var ScreenType;
(function (ScreenType) {
    ScreenType["WINDOW"] = "window";
    ScreenType["SCREEN"] = "screen";
})(ScreenType = exports.ScreenType || (exports.ScreenType = {}));
var OpenviduRole;
(function (OpenviduRole) {
    OpenviduRole["SUBSCRIBER"] = "SUBSCRIBER";
    OpenviduRole["PUBLISHER"] = "PUBLISHER";
    OpenviduRole["MODERATOR"] = "MODERATOR";
})(OpenviduRole = exports.OpenviduRole || (exports.OpenviduRole = {}));
var PARTICIPANTS_FILTER;
(function (PARTICIPANTS_FILTER) {
    PARTICIPANTS_FILTER["ALL"] = "vc.all_participants";
    PARTICIPANTS_FILTER["BENCH_MEMBER"] = "vc.bench_members";
    PARTICIPANTS_FILTER["COURT_STAFF"] = "vc.court_staff";
    PARTICIPANTS_FILTER["OTHER_PARTICIPANT"] = "vc.other_participants";
})(PARTICIPANTS_FILTER = exports.PARTICIPANTS_FILTER || (exports.PARTICIPANTS_FILTER = {}));
var VC_ACTIONS;
(function (VC_ACTIONS) {
    VC_ACTIONS["MUTE_ALL"] = "vc.action.mute_all";
    VC_ACTIONS["MUTE"] = "vc.action.mute";
    VC_ACTIONS["BLOCK"] = "vc.action.block";
    VC_ACTIONS["TURN_ON_VIDEO"] = "vc.turn_on_video";
    VC_ACTIONS["TURN_ON_VIDEO_ALL"] = "vc.turn_on_video_all";
})(VC_ACTIONS = exports.VC_ACTIONS || (exports.VC_ACTIONS = {}));
//# sourceMappingURL=types.js.map